import React from 'react';
import cn from 'classnames';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { ISpinnerOverlayProps } from './SpinnerOverlay.types';

import Spinner from '../Spinner';

import './SpinnerOverlay.scss';

const SpinnerOverlay: React.FC<ISpinnerOverlayProps> = ({
	size,
	bottomText,
	bottomTextSize = 16,
	spinnerId,
	spinnerColorId,
	className,
}) => {
	const { branding } = useAppSelector(auth);

	const isSpinnerIdProps = spinnerId !== undefined && spinnerColorId !== undefined;

	return (
		<div
			className={cn('f5gSpinnerOverlayContainer', className)}
			data-testid='spinner-overlay'
		>
			<Spinner
				size={size}
				spinnerColorId={isSpinnerIdProps ? spinnerColorId : branding?.spinnerColorId}
				spinnerId={isSpinnerIdProps ? spinnerId : branding?.spinnerId}
			/>
			{bottomText && (
				<div
					className='f5gSpinnerOverlayContainer-bottomText'
					style={{
						fontSize: bottomTextSize,
					}}
				>
					{bottomText}
				</div>
			)}
		</div>
	);
};

export default SpinnerOverlay;
